import { useEffect, useState } from "react";
import API from "../lib/api";

function timeAgo(iso) {
  if (!iso) return "";
  try {
    const diff = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  } catch { return ""; }
}

export default function PaymentProofsTicker() {
  const [data, setData] = useState({ ticker: [], settings: { ticker_enabled: false } });

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await API.get("/payment-proofs");
        if (alive) setData(data);
      } catch { /* ignore */ }
    };
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!data.settings?.ticker_enabled || !data.ticker || data.ticker.length === 0) return null;

  // Duplicate the items so the marquee loops seamlessly
  const items = [...data.ticker, ...data.ticker];

  return (
    <div className="w-full bg-[#10B981]/10 border-b border-[#10B981]/20 overflow-hidden" data-testid="proofs-ticker">
      <div className="flex items-center max-w-7xl mx-auto">
        <div className="flex-shrink-0 px-4 py-2 bg-[#10B981]/20 border-r border-[#10B981]/30">
          <span className="text-[10px] font-bold tracking-widest text-[#10B981] uppercase animate-pulse">● LIVE</span>
        </div>
        <div className="relative overflow-hidden flex-1 py-2">
          <div className="flex gap-8 whitespace-nowrap proofs-ticker-track">
            {items.map((it, i) => (
              <span key={i} className="text-xs text-[#94A3B8]">
                <span className="font-bold text-[#F8FAFC]">{it.username}</span>
                {" "}<span className="text-[#64748B]">just</span>{" "}
                <span style={{ color: it.kind === "deposit" ? "#10B981" : "#FFD600" }}>
                  {it.kind === "deposit" ? "deposited" : "received"}
                </span>
                {" "}<span className="font-mono-game font-bold text-[#F8FAFC]">${(it.amount || 0).toFixed(2)}</span>
                {" "}<span className="text-[#FFD600] font-mono-game">{it.currency}</span>
                {" "}<span className="text-[#64748B]">·</span>{" "}
                <span className="text-[#64748B]">{timeAgo(it.created_at)}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes proofs-ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .proofs-ticker-track {
          animation: proofs-ticker-scroll 60s linear infinite;
        }
      `}</style>
    </div>
  );
}
